import { render, staticRenderFns } from "./TabelaBusca.vue?vue&type=template&id=56bda46b"
import script from "./TabelaBusca.vue?vue&type=script&lang=js"
export * from "./TabelaBusca.vue?vue&type=script&lang=js"
import style0 from "./TabelaBusca.vue?vue&type=style&index=0&id=56bda46b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports